import React from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';

import { useModal } from '../../Modal/ModalContext';
import { useTimeModal } from '../../TimeModal/TimeModalContext';

import LoadingLines from '../../LoadingLines';
import Loading from '../../Loading';
import WarningPanel from '../../WarningPanel';
import IconContainer from '../../IconContainer';
import { ReactComponent as CopyIcon } from '../../../icons/copy.svg';

const AMWithoutRegions = ({ onReloadTable, setOnReloadTable }) => {
    const { openTimeModal } = useTimeModal();
    const navigate = useNavigate();
    const location = useLocation();

    const [users, setUsers] = React.useState([]);
    const [counts, setCounts] = React.useState('');
    const [reload, setReload] = React.useState(true);
    const [warning, setWarning] = React.useState('');
    const [loading, setLoading] = React.useState(true);

    const [limitForView, setLimitForView] = React.useState(50);
    const [visibilityBtn, setVisibilityBtn] = React.useState(false);


    React.useEffect(() => {
        setLoading(true);

        const token = localStorage.getItem('token');
        axios.get(`/api/get-am-without-regions?limitForView=${limitForView}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(response => {
            if (response.data.length === 0) {
                setUsers([]);
                setWarning('Все управляющие прикреплены как минимум к одному региону');
                setVisibilityBtn(false);
            } else {
                setUsers(response.data);
                setWarning('');
                setVisibilityBtn(response.data.length >= limitForView);
            }
        })
        .catch((error) => {
            console.error(error);
            setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
        }).finally(() => {
            setReload(false);
            setLoading(false);
            setOnReloadTable(false);
        });

        axios.get(`/api/get-count-am`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(response => {
            setCounts(response.data);
        })
        .catch((error) => {
            console.error(error);
        });
    }, [reload, onReloadTable]);

    const downloadListOfUnregistered = () => {
        const token = localStorage.getItem('token');
        axios.get(`/api/get-list-unregistered-users`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            responseType: 'blob',
        })
        .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'unregistered_emails.txt');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
            console.error(error);
            openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
        });
    };

    return (
    <>
        <div className='horizontalContainer'>
            <div className='boxPage'>
                <div className='boxHeader'>
                    <h3>Сводка</h3>
                </div>
                <div className='boxMain'>
                    {loading ? <Loading type='inline' /> 
                    : 
                    <>
                    <p style={{fontSize: '14px'}}>Количество арбитражных управляющих, зарегистрированных в системе: {counts.total_am} ({counts.total_am_2weeks} зарегистрировались за последние две недели)</p>
                    <p style={{fontSize: '14px', display: 'flex', alignItems: 'center', gap: '10px'}}>Количество адресов управляющих по спискам СРО: {counts.total_am_emails} {counts.total_am_emails>0 && <button type='button' className='tableButton' onClick={() => {downloadListOfUnregistered()}}>Скачать список управляющих, не прошедших регистрацию</button>}</p>
                    </>}
                </div>
                <div className='boxBottom'></div>
            </div>
        </div>
        <div className='tableContainer'>
            <div className='tableHeaderWrapper'>
                <div className='tableStatus'>
                    <p>Управляющие без регионов</p>
                </div>
                <div className='tableHeader' style={{gridTemplateColumns: '1fr 1fr 1fr'}}>
                    <div>ФИО</div>
                    <div>Email</div>
                    <div>Статус</div>
                </div>
            </div>
            {loading ? <LoadingLines count='5' heightLine='72' />
            : warning ? <WarningPanel text={warning} inTable={true} buttonText='Обновить' buttonAction={() => setReload(true)} />
            : users.map((user) => (
                <div className='tableRow nonActive' key={user.id} style={{gridTemplateColumns: '1fr 1fr 1fr'}}>
                    <div className='aWithLink' style={{cursor: 'pointer'}} onClick={() => navigate(`/account/${user.id}`, { state: { from: location.pathname + location.search + location.hash } })}>
                        {user.lastname} {user.firstname} {user.surname}
                    </div>
                    <div>
                        <span style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
                            {user.email}
                            <IconContainer 
                                Icon={CopyIcon} 
                                label={'Скопировать'} 
                                onClick={() => {
                                    navigator.clipboard.writeText(user.email);
                                    openTimeModal('Email скопирован', 'success');
                                }} 
                                size = '15' 
                                color = 'black' 
                                className = '' 
                            />
                        </span>
                    </div>
                    <div>
                        {user.approval === 'Активен' && <p className='textPill green'>Зарегистрирован</p>} 
                        {user.approval === 'На рассмотрении' && <p className='textPill blue'>На рассмотрении</p>} 
                        {user.approval === 'Отключен' && <p className='textPill orange'>Отключен</p>} 
                    </div>
                </div>
            ))}
            {visibilityBtn && <span style={{display: 'flex', justifyContent: 'center'}}><button type='button' className='button' onClick={() => {setLimitForView(prev => prev + 50); setReload(true)}}>Загрузить ещё</button></span>}
        </div>
    </>
    )
}

export default AMWithoutRegions;